<ik-header
  (backBtnClicked)="prev()"
></ik-header>

<div class="step" [class.step--hidden]="isStepHidden">
  <ik-screen-step></ik-screen-step>
</div>

<div class="container">
  <div class="slider"  [class.slider--move-next]="moveNext" [class.slider--move-prev]="movePrev">
    <div class="current">
      <ng-container>
        <ng-template #currentContainer></ng-template>
      </ng-container>
    </div>
    <div class="next">
      <ng-template #nextContainer></ng-template>
    </div>
  </div>
</div>

